export default "__VITE_ASSET__CLPeSoJi__"